// eslint-disable-next-line @rushstack/no-new-null
export function isQueryLoading<T>(isLoading: boolean, data: T | null | undefined): data is null | undefined {
  return isLoading;
}
